import '../../App.css';
import '../../assets/css/admin.css';
import { Col, Row, Card, Breadcrumb, Badge, Table, CardBody } from 'react-bootstrap';
import React, { useEffect, useState, useRef } from "react";
import moment from 'moment';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Button } from 'primereact/button';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import { TbUsersMinus } from "react-icons/tb";
import { TbBeach } from "react-icons/tb"
import { PiUsersFourLight } from "react-icons/pi";
import { LiaHourglassHalfSolid } from "react-icons/lia";
import { Dialog } from 'primereact/dialog';
import { Tooltip } from 'primereact/tooltip';
import Marquee from "react-fast-marquee";
import { VscFlame } from "react-icons/vsc";
import { PiFlagBannerFill } from "react-icons/pi";
import Dash_evntcal from '../../components/Dash_evntcal';
import Brand_postcal from '../../components/Brand_postcal';
import { TabView, TabPanel } from 'primereact/tabview';
import { Sidebar } from 'primereact/sidebar';
import Meeting_notes from '../../components/Meeting_notes';
import noUserImg from '../../assets/images/no_user.png'; // Placeholder for missing profile images
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Carousel } from 'primereact/carousel';
import { Tag } from 'primereact/tag';
import { IoHandRightSharp } from "react-icons/io5";
import { FaSkullCrossbones } from "react-icons/fa";
import { CgFlagAlt } from "react-icons/cg";
import { getSocket } from '../../context/socket';
import View_edit_taskdetails from '../../modalPopup/View_edit_taskdetails';
const Employee_dash = () => {
    const { accessToken, userId, role } = useAuth();
    const [taskSummary, setTaskSummary] = useState(null);
    const [attendanceData, setAttendanceData] = useState(null);
    const [tasksheets, setTasksheets] = useState([]);
    const [loading, setLoading] = useState(false);
    const [visibleRight, setVisibleRight] = useState(false);
    const [taggedComments, setTaggedComments] = useState([]);
    const navigate = useNavigate();
    const socket = getSocket();
    const [tasks, setTasks] = useState({
        today_tasks: [],
        pending_tasks: [],
        urgent_tasks: [],
        missed_deadlines: [],
    });
    const [cardStats, setCardStats] = useState({
        todoTasks: [],
        pendingTasks: [],
        urgentTasks: [],
        missedDeadlines: [],
    });
    const [userCardData, setUserCardData] = useState({
        urgentNotCompleted: [],
        todoCards: [],
        missedDeadline: [],
        others: []
    });


    const [dateRange, setDateRange] = useState(() => {
        const range = localStorage.getItem("CommentsDateRange");
        if (range) {
            const parsedRange = JSON.parse(range);
            return {
                startDate: moment(parsedRange.startDate), // Convert back to moment object
                endDate: moment(parsedRange.endDate), // Convert back to moment object
            };
        }
        return {
            startDate: moment().startOf("week"),
            endDate: moment().endOf("week"),
        };
    });

    useEffect(() => {
        localStorage.setItem(
            "CommentsDateRange",
            JSON.stringify({
                startDate: dateRange.startDate.toISOString(), // Store as ISO string
                endDate: dateRange.endDate.toISOString(), // Store as ISO string
            })
        );
    }, [dateRange]);


    const [visible, setVisible] = useState(false);
    const [position, setPosition] = useState('top-right');
    const [selectedTaskId, setSelectedTaskId] = useState(null);
    const [board_id, setBoardId] = useState(null); // Add this
    const showDialog = (position, taskId, boardId) => {
        setPosition(position);
        setSelectedTaskId(taskId);
        setBoardId(boardId);
        setVisible(true);
    };

    // Handle dialog close
    const handleDialogClose = () => {
        if (!visible) return;
        setVisible(false);
    };



    // Handle date range change
    const handleDateRangeChange = (start, end) => {
        setDateRange({
            startDate: moment(start).local(),
            endDate: moment(end).local(),
        });
    };


    useEffect(() => {
        if (socket && userId) {
            socket.emit('fetchCardCommentsByUser', { user_id: userId });

            const handleCardCommentsData = (data) => {
                const cardsWithTaggedComments = data.filter(card =>
                    card.sections?.some(section =>
                        (section.images && section.images.some(image => image.comments?.length > 0)) ||
                        (section.files && section.files.some(file => file.comments?.length > 0)) ||
                        (section.links && section.links.some(link => link.comments?.length > 0)) ||
                        (section.meetings && section.meetings.length > 0)
                    )
                );
                setTaggedComments(cardsWithTaggedComments);
            };

            socket.on('cardCommentsData', handleCardCommentsData);

            return () => {
                socket.off('cardCommentsData', handleCardCommentsData);
            };
        }
    }, [socket, userId]);

    useEffect(() => {
        if (!userId) return;

        const socket = getSocket();

        const now = moment(); // today
        const yesterday = moment().subtract(1, 'days'); // yesterday

        const startDate = yesterday.startOf('day').format('YYYY-MM-DD');
        const endDate = now.startOf('day').format('YYYY-MM-DD');
        socket.emit("fetchUserTaskSheetByDate", {
            user_id: userId,
            start_date: startDate,
            end_date: endDate,
        });

        socket.on("userTaskSheetFetched", ({ success, data }) => {
            if (success) {
                setTasksheets(data); // ✅ keep the original shape
            }
        });

        return () => {
            socket.off("userTaskSheetFetched");
        };
    }, [userId]);

    // Flatten the data for Carousel
    const flattenedTasksheets = Object.values(tasksheets).flat();


    useEffect(() => {
        if (!userId || !socket) return;

        socket.emit("fetchCardStats", { user_id: userId });

        socket.on("cardStatsFetched", ({ success, data }) => {
            if (success) {
                setCardStats({
                    todoTasks: Array(data.todoCount).fill({}),
                    pendingTasks: Array(data.notTodoOrCompleted).fill({}),
                    urgentTasks: Array(data.urgentNotCompleted).fill({}),
                    missedDeadlines: Array(data.missedDeadline).fill({})
                });
            }
        });

        return () => {
            socket.off("cardStatsFetched");
        };
    }, [userId, socket]);
    useEffect(() => {
        if (!socket) return;

        socket.emit('fetchUserCardData', { user_id: userId });

        socket.on('userCardDataFetched', (response) => {
            if (response.success && response.data) {
                setUserCardData(response.data);
            }
        });

        // Clean up the socket listener
        return () => {
            socket.off('userCardDataFetched');
        };
    }, [socket, userId]);


    useEffect(() => {
        const fetchTasks = async () => {
            try {
                const response = await axios.get(`${config.apiBASEURL}/projectRoutes/tasks/categorized/${userId}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                if (response.data.success) {
                    setTasks(response.data.data);
                }
            } catch (error) {
                console.error('Error fetching tasks:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchTasks();
    }, [accessToken, userId]);


    useEffect(() => {
        const fetchTaskSummary = async () => {
            try {
                const response = await axios.get(`${config.apiBASEURL}/projectRoutes/specific-user-task-summary`, {
                    params: { user_id: userId },
                    headers: {
                        Authorization: `Bearer ${accessToken}`, // Add the Authorization header
                    },
                });
                setTaskSummary(response.data.summary);
            } catch (error) {
                console.error('Error fetching task summary:', error);
            }
        };

        fetchTaskSummary();
    }, [accessToken, userId]);


    useEffect(() => {
        const fetchAttendanceData = async () => {
            try {
                const response = await axios.get(`${config.apiBASEURL}/employee-report/dashboard-Employee-report-attendance`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                    params: {
                        userId: userId,
                    },
                });
                setAttendanceData(response.data);
            } catch (error) {
                console.error('Error fetching attendance data:', error);
            }
        };

        fetchAttendanceData();
    }, [accessToken, userId]);






    const renderTasks = (data, columnType) => {
        // Define how many columns each columnType should render
        const columnCounts = {
            today: 4,
            pending: 4,
            urgent: 4,
            missed: 4,
            // fallback/default if a new columnType is added
            default: 4,
        };

        const colSpan = columnCounts[columnType] || columnCounts.default;

        // Safeguard for empty or invalid data
        if (!Array.isArray(data) || data.length === 0) {
            return (
                <tr>
                    <td colSpan={colSpan} style={{ textAlign: 'center' }}>
                        No tasks available.
                    </td>
                </tr>
            );
        }
        return data.map((task, index) => {
            const brandName = task?.list?.board?.brand?.brand_name || 'N/A';
            const projectName = task?.list?.board?.project?.project_name || 'N/A';
            const taskName = task?.title || 'N/A';
            const createdAt = task?.createdAt;
            const dueDate = task?.due_date;
            const boardId = task?.board_id;
            const cardId = task?.card_id;
            const formattedDeadline = (
                <small
                    className={`text-white rounded ${getDueDateClass(dueDate)}`}
                    style={{ fontSize: '11px', padding: '2px 5px' }}
                >
                    <i className="pi pi-calendar" style={{ fontSize: '11px' }}></i>{" "}
                    {formatDate(createdAt)} - {formatDate(dueDate)}
                </small>
            );

            const status = (
                <span
                    style={{
                        fontSize: '12px',
                        backgroundColor: task?.list?.color_code || '#ccc',
                        color: '#fff',
                        padding: '0px 5px',
                        borderRadius: '4px',
                        display: 'inline-block',
                    }}
                >
                    {task?.list?.name || 'N/A'}
                </span>
            );

            return (
                <tr key={index}
                    onClick={() => showDialog('top-right', cardId, boardId)}
                    style={{ cursor: 'pointer' }}
                >
                    {columnType === 'today' && (
                        <>
                            <td>{brandName}</td>
                            <td>{projectName}</td>
                            <td>{taskName}</td>
                            <td>{status}</td>
                        </>
                    )}

                    {['pending', 'urgent', 'missed'].includes(columnType) && (
                        <>
                            <td>{brandName}</td>
                            <td>{taskName}</td>
                            <td>{formattedDeadline}</td>
                            <td>{status}</td>
                        </>
                    )}
                </tr>
            );
        });
    };





    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const options = { day: 'numeric', month: 'short' }; // e.g., "7 Apr"
        return date.toLocaleDateString('en-US', options);
    };

    const getDueDateClass = (dueDate) => {
        if (!dueDate) return "";

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const due = new Date(dueDate);
        due.setHours(0, 0, 0, 0);

        const diffDays = (due - today) / (1000 * 60 * 60 * 24);

        if (diffDays < 0) {
            return "bg-danger"; // Passed
        } else if (diffDays === 0) {
            return "bg-danger"; // Today
        } else if (diffDays === 1) {
            return "bg-warning"; // Tomorrow
        } else {
            return "bg-success"; // Future
        }
    };

    /*--------------pjRep----------------*/

    const sectionRef = useRef(null);

    const scrollToSection = (event) => {
        event.preventDefault(); // Prevent default anchor behavior

        if (sectionRef.current) {
            sectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    /*--------------------taskSlid----------------*/


    const responsiveOptions = [
        {
            breakpoint: '1400px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '991px',
            numVisible: 1,
            numScroll: 1
        },
        {
            breakpoint: '575px',
            numVisible: 1,
            numScroll: 1
        }
    ];



    const productTemplate = (entry) => {
        const card = entry.card;
        return (
            <Card className="m-2 p-3 shadow-sm dashNewtask">
                <Card.Body className='p-0'>
                    <ul className="list-unstyled mb-0">
                        <li className="mb-3">
                            <p>
                                <span>Brand:</span> {card?.list?.board?.brand?.brand_name || 'No brand'}
                                {card?.priority === 'Urgent' && (
                                    <small className="misses_image2 ms-2">
                                        <PiFlagBannerFill />
                                    </small>
                                )}
                            </p>
                            {card?.missed_deadline && (
                                <div className="misses_image">
                                    <VscFlame />
                                </div>
                            )}
                            <p>
                                <span>Project:</span> {card?.list?.board?.project?.project_name || 'No project'}
                            </p>
                            <p>
                                <span>Board:</span> {card?.list?.board?.name || 'NA'}
                            </p>
                            <p>
                                <span>Task:</span> {card?.title || 'No task'}
                            </p>

                            <p className="d-flex">
                                <span
                                    style={{
                                        fontSize: '12px',
                                        backgroundColor: card?.list?.color_code || '#ccc',
                                        color: '#fff',
                                        padding: '0px 5px',
                                        borderRadius: '4px',
                                        display: 'inline-block'
                                    }}
                                >
                                    {card?.list?.name}
                                </span>
                                <small className={`text-white ms-2 rounded ${getDueDateClass(card?.due_date)}`} style={{ fontSize: '11px', padding: '2px 5px' }}>
                                    <i className="pi pi-calendar" style={{ fontSize: '11px' }}></i>
                                    {" "}{formatDate(card?.createdAt)} - {formatDate(card?.due_date)}
                                </small>
                            </p>

                            <p className="mb-0 text-bold text-danger">
                                
                            </p>
                        </li>
                    </ul>
                </Card.Body>
            </Card>
        );
    };



    return (
        <>
            <Row className='body_content'>
                <Row className='mx-0'>
                    <Col md={6} lg={6} xs={12} className='mb-lg-4 mb-3 text-center d-flex justify-content-lg-start justify-content-center'>
                        <Breadcrumb>
                            <Breadcrumb.Item active>Dashboard</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Col md={6} lg={6} xs={12} className='mb-lg-4 pb-lg-0 pb-5 mb-5 d-flex justify-content-lg-end justify-content-center'>

                        <Button
                            label="Leaves"
                            icon="pi pi-eye"
                            severity="help"
                            className="py-2 border-0 ms-2"
                            onClick={() => navigate('/Graphe/dashboard/leave_apply')} // Navigate on click
                        />
                        <Button
                            label="Overtime"
                            icon="pi pi-stopwatch"
                            severity="warning"
                            className="py-2 border-0 ms-2 "
                            onClick={() => navigate('/Graphe/dashboard/employee-overtime')} // Navigate on click
                        />
                        <Button
                            label='Meeting Notes'
                            icon='pi pi-headphones'
                            severity='primary'
                            className='border-0 py-2 ms-2'
                            onClick={() => setVisibleRight(true)}
                        />
                    </Col>
                    <Col md={12} lg={8} className='mb-4'>
                        <Card className='dashboard_week'>
                            <TabView>
                                <TabPanel header="Event Calendar">
                                    <Dash_evntcal />
                                </TabPanel>
                                {(role === "Social_Media_Manager" || role === "Task_manager") && (
                                    <TabPanel header="Brand Calendar">
                                        <Brand_postcal />
                                    </TabPanel>
                                )}

                            </TabView>
                        </Card>
                    </Col>
                    <Col md={12} lg={4} className='mb-4'>
                        <Card className='dashboard_week h-100 p-0'>
                            <Card.Body>
                                <ul className='pjRep'>
                                    <li>
                                        <Link to="#pjRep1" onClick={scrollToSection}>
                                            <span>Todo Task : </span>
                                            <h5 className='text-info'>
                                                {cardStats.todoTasks.length}
                                            </h5>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#pjRep2" onClick={scrollToSection}>
                                            <span>Pending Task : </span>
                                            <h5>
                                                {cardStats.pendingTasks.length}
                                            </h5>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#pjRep3" onClick={scrollToSection}>
                                            <span>Urgent Task : </span>
                                            <h5>
                                                {cardStats.urgentTasks.length}
                                            </h5>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#pjRep4" onClick={scrollToSection}>
                                            <span>Missed Deadlines : </span>
                                            <h5 className='text-danger'>
                                                {cardStats.missedDeadlines.length}
                                            </h5>
                                        </Link>
                                    </li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Row className="mb-3 mx-0">
                        <Col lg={6} className="mb-3">
                            <Card>
                                <Card.Header className="d-flex justify-content-between align-items-center">
                                    <h6>
                                        Daily Task
                                        <small><Badge className='bg-danger ms-2'>{flattenedTasksheets.length}</Badge></small>
                                    </h6>
                                    <Button
                                        label="View All"
                                        className="p-0 border-0"
                                        severity="info"
                                        outlined
                                        onClick={() => navigate('/Graphe/dashboard/employee_dailytask')} // Navigate on click
                                    />
                                </Card.Header>
                                <Card.Body className='table-scroll px-0 pb-2'>
                                    <Carousel
                                        value={flattenedTasksheets}
                                        numVisible={2}
                                        numScroll={1}
                                        responsiveOptions={responsiveOptions}
                                        itemTemplate={productTemplate}
                                        circular
                                        autoplayInterval={5000}
                                    />

                                </Card.Body>
                            </Card>
                        </Col>

                        <Col lg={6} className="mb-3">
                            <Card className="h-100">
                                <Card.Header className="d-flex justify-content-between align-items-center">
                                    <h6 className="mb-0">
                                        Task Comments
                                    </h6>
                                    {/* <div>
                                        <DateRangePicker
                                            initialSettings={{
                                                startDate: dateRange.startDate,
                                                endDate: dateRange.endDate,
                                                locale: { format: "DD/MM/YYYY" },
                                                ranges: {
                                                    Today: [moment(), moment()],
                                                    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                                                    "Last 7 Days": [moment().subtract(6, "days"), moment()],
                                                },
                                            }}
                                            onCallback={handleDateRangeChange}
                                        >
                                            <input
                                                type="text"
                                                className="dashDate"
                                                placeholder="Select Date Range"
                                            />
                                        </DateRangePicker>
                                    </div> */}
                                </Card.Header>
                                <Card.Body className="table-scroll">
                                    {taggedComments.length === 0 && (
                                        <div className="text-center text-muted">No tagged comments found.</div>
                                    )}
                                    <ul className="tcm_list">
                                        {taggedComments.map((card, cardIdx) =>
                                            card.sections.map((section, secIdx) => {
                                                let content = null;
                                                let type = null;

                                                if (section.images?.some(img => img.comments?.length)) {
                                                    content = section.images.find(img => img.comments?.length);
                                                    type = 'image';
                                                } else if (section.files?.some(file => file.comments?.length)) {
                                                    content = section.files.find(file => file.comments?.length);
                                                    type = 'file';
                                                } else if (section.links?.some(link => link.comments?.length)) {
                                                    content = section.links.find(link => link.comments?.length);
                                                    type = 'link';
                                                } else if (section.meetings?.length) {
                                                    content = section.meetings[0];
                                                    type = 'meeting';
                                                }

                                                if (!content) return null;

                                                const comments = content.comments || [];

                                                // Dynamically get display name and icon
                                                let displayName = '';
                                                let icon = '';
                                                switch (type) {
                                                    case 'image':
                                                        displayName = content.filename || 'Image';

                                                        icon = 'pi pi-image';
                                                        break;
                                                    case 'file':
                                                        displayName = content.filename || 'File';

                                                        icon = 'pi pi-file';
                                                        break;
                                                    case 'link':
                                                        displayName = content.title || 'Link';
                                                        icon = 'pi pi-link';
                                                        break;
                                                    case 'meeting':
                                                        displayName = content.meeting_title || 'Meeting';
                                                        icon = 'pi pi-users';
                                                        break;
                                                    default:
                                                        displayName = 'Unnamed';
                                                        icon = 'pi pi-question';
                                                }

                                                const tooltipTargetId = `tooltip-${cardIdx}-${secIdx}`;

                                                return (
                                                    <li key={`${cardIdx}-${secIdx}`}>
                                                        <Link to="#!" className={`custom-tooltip-btn ${tooltipTargetId}`
                                                        } onClick={(e) => {
                                                            e.preventDefault();
                                                            showDialog('top-right', card.card_id, card.board_id);
                                                        }
                                                        }>
                                                            <div className="cmImage">
                                                                <i className={icon}></i>
                                                                {comments.length > 0 && (
                                                                    <Badge className="bg-danger ms-1">{comments.length}</Badge>
                                                                )}
                                                            </div>
                                                            <div className="cmdata">
                                                                <span>
                                                                    <small>Task:</small> {card.title || "No comments yet."}
                                                                </span>
                                                                <span className="d-flex w-100">
                                                                    <small>Brand:</small> {card.list?.board?.brand?.brand_name || "No brand"}
                                                                </span>
                                                                <span className="d-flex w-100">
                                                                    <small>Section:</small> {displayName}
                                                                </span>

                                                            </div>
                                                        </Link>
                                                        <Tooltip target={`.${tooltipTargetId}`} className="comtooltip">
                                                            <ol>
                                                                {comments.map((comment, cIdx) => (
                                                                    <li key={cIdx}>
                                                                        <span className="d-block mb-1 text-secondary">
                                                                            {comment.creator?.first_name} {comment.creator?.last_name} |{" "}
                                                                            {moment(comment.createdAt).format("DD/MM/YYYY")}
                                                                        </span>
                                                                        {comment.comment_text}
                                                                    </li>
                                                                ))}
                                                            </ol>
                                                        </Tooltip>
                                                    </li>
                                                );
                                            })
                                        )}
                                    </ul>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* <Col lg={6} className='resp_report mb-lg-0 mb-3'>
                            <Card>
                                <Card.Header>
                                    <h6>
                                        Project Report <sub>/ Month</sub>
                                    </h6>
                                </Card.Header>
                                <Card.Body>
                                    {taskSummary ? (
                                        <Table className="repTable">
                                            <thead>
                                                <tr>
                                                    <td>Todo</td>
                                                    <td>In Progress</td>
                                                    <td>In Review</td>
                                                    <td>In Changes</td>
                                                    <td>Completed</td>
                                                    <td className="text-danger">Missed Deadlines</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th>{taskSummary.Todo}</th>
                                                    <th>{taskSummary.InProgress}</th>
                                                    <th>{taskSummary.InReview}</th>
                                                    <th>{taskSummary.InChanges}</th>
                                                    <th>{taskSummary.Completed}</th>
                                                    <th className="text-danger">{taskSummary.missedDeadlines}</th>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    ) : (
                                        <p>Loading task summary...</p>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col lg={6} className='resp_report mb-lg-0 mb-3'>
                            <Card className="">
                                <Card.Header>
                                    <h6>Attendance Report <sub>/ Month</sub></h6>
                                </Card.Header>
                                <Card.Body>
                                    {attendanceData ? (
                                        <Table className="repTable">
                                            <thead>
                                                <tr>
                                                    <td>Absent</td>
                                                    <td>Present</td>
                                                    <td>Approved Overtime</td>
                                                    <td>No.of Late </td>
                                                    <td>Working Days <sup className="text-danger">Total</sup></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th>{attendanceData.totalAbsentDays}</th>
                                                    <th>{attendanceData.totalPresentDays}</th>
                                                    <th className="custom-tooltip-btn4 cursor-pointer">
                                                        {attendanceData.totalOvertimeHours}<small className="text-danger"><sub>/ hrs</sub></small>

                                                    </th>
                                                    <th className="custom-tooltip-btn5 cursor-pointer">
                                                        {attendanceData.totalLateCount}<i className="pi pi-angle-right"></i>
                                                        <Tooltip target=".custom-tooltip-btn5">
                                                            <p><b>No.of Late</b></p>
                                                            <ol className="toltioList w-auto">
                                                                {attendanceData.lateDays.map((date, index) => (
                                                                    <li className="d-block" key={index}>
                                                                        <span>{moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY')}</span>
                                                                    </li>
                                                                ))}
                                                            </ol>
                                                        </Tooltip>


                                                    </th>
                                                    <th>{attendanceData.totalDaysInMonth}</th>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    ) : (
                                        <p>Loading task summary...</p>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col> */}
                    </Row>


                    <Row>
                        {loading ? (
                            <div>Loading...</div>
                        ) : (
                            <>
                                <Col lg={6} className='mb-lg-0 mb-3 resp_report' id='pjRep1' ref={sectionRef}>
                                    <Card className="emp_list_card p-0">
                                        <Card.Header className="d-flex justify-content-between align-items-center">
                                            <b>
                                                Todo Task <sup><Badge className="bg-danger">{userCardData.todoCards.length}</Badge></sup>
                                            </b>

                                        </Card.Header>
                                        <Card.Body className="table-scroll">
                                            <Table size="sm" className="text-left">
                                                <thead>
                                                    <tr>
                                                        <th>Brand Name</th>
                                                        <th>Project Name</th>
                                                        <th>Task Name</th>
                                                        <th style={{ width: '80px' }}>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>{renderTasks(userCardData.todoCards, 'today')}</tbody>
                                            </Table>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                {/* Similar for Pending Tasks */}
                                <Col lg={6} className='mb-lg-0 mb-3 resp_report' id='pjRep2' ref={sectionRef}>
                                    <Card className="emp_list_card p-0">
                                        <Card.Header className="d-flex justify-content-between align-items-center">
                                            <b>
                                                Pending Tasks <sup><Badge className="bg-danger">{userCardData.others.length}</Badge></sup>
                                            </b>

                                        </Card.Header>
                                        <Card.Body className="table-scroll">
                                            <Table size="sm" className="text-left">
                                                <thead>
                                                    <tr>
                                                        <th>Brand Name</th>
                                                        <th>Task Name</th>
                                                        <th>Deadlines</th>
                                                        <th style={{ width: '80px' }}>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>{renderTasks(userCardData.others, 'pending')}</tbody>
                                            </Table>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                {/* Similar for Urgent Tasks */}
                                <Col lg={6} className='mb-lg-0 mb-3 resp_report' id='pjRep3' ref={sectionRef}>
                                    <Card className="emp_list_card p-0">
                                        <Card.Header className="d-flex justify-content-between align-items-center">
                                            <b>
                                                Urgent Tasks <sup><Badge className="bg-danger">{userCardData.urgentNotCompleted.length}</Badge></sup>
                                            </b>

                                        </Card.Header>
                                        <Card.Body className="table-scroll">
                                            <Table size="sm" className="text-left">
                                                <thead>
                                                    <tr>
                                                        <th>Brand Name</th>
                                                        <th>Task Name</th>
                                                        <th>Deadlines</th>
                                                        <th style={{ width: '80px' }}>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>{renderTasks(userCardData.urgentNotCompleted, 'urgent')}</tbody>
                                            </Table>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                {/* Similar for Missed Deadlines */}
                                <Col lg={6} className='mb-lg-0 mb-3 resp_report' id='pjRep4' ref={sectionRef}>
                                    <Card className="emp_list_card p-0">
                                        <Card.Header className="d-flex justify-content-between align-items-center">
                                            <b>
                                                Missed Deadlines <sup><Badge className="bg-danger">{userCardData.missedDeadline.length}</Badge></sup>
                                            </b>

                                        </Card.Header>
                                        <Card.Body className="table-scroll">
                                            <Table size="sm" className="text-left">
                                                <thead>
                                                    <tr>
                                                        <th>Brand Name</th>
                                                        <th>Task Name</th>
                                                        <th>Deadlines</th>
                                                        <th style={{ width: '80px' }}>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>{renderTasks(userCardData.missedDeadline, 'missed')}</tbody>
                                            </Table>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </>
                        )}
                    </Row>
                </Row>
            </Row>
            <Sidebar visible={visibleRight} position="right" onHide={() => setVisibleRight(false)} style={{ width: '550px' }} className='meetingNotes'>
                <Meeting_notes />
            </Sidebar>

            <Dialog
                visible={visible}
                position={position}
                style={{ width: '1000px', margin: '0', borderRadius: '0', height: '100%' }}
                onHide={handleDialogClose}
                draggable={false}
                resizable={false}
                className="KanbanDialog"
            >
                <View_edit_taskdetails taskId={selectedTaskId} boardId={board_id} onClose={handleDialogClose} />
            </Dialog>
        </>

    )
};



export default Employee_dash;